<div class="nav-backdrop" *ngIf="isMenuOpen" (click)="closeMenu()" [@fadeInOut]></div>
<div class="nav-container horizinns-bottom-nav">
  <nav class="pill-nav" [class.menu-active]="isMenuOpen">
    
    <ng-container *ngIf="!isMenuOpen">
      <a *ngFor="let item of navItems" 
         [routerLink]="item.path"
         routerLinkActive="active-route" 
         [routerLinkActiveOptions]="item.path === '/' ? {exact: true} : {exact: false}"
         (click)="onClick()"
         class="nav-item">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span class="label">{{ item.label }}</span>
      </a>
    </ng-container>

    <div class="menu-grid" *ngIf="isMenuOpen">
      <div class="nav-user-info" *ngIf="user">
        <div class="user_name">
          {{ user?.firstName }} {{ user?.lastName }}
        </div>
        <div class="user_id">
          {{ user?.username }}
        </div>
      </div>
      <button class="menu-action" (click)="onAddClick('login')" *ngIf="!user">
        <mat-icon>login</mat-icon>
        <span>Login</span>
      </button>
      <button class="menu-action" (click)="onAddClick('home')">
        <mat-icon>home</mat-icon>
        <span>Home</span>
      </button>
      <button class="menu-action" (click)="onAddClick('search')">
        <mat-icon>search</mat-icon>
        <span>Search</span>
      </button>
      <button class="menu-action" (click)="onAddClick('saved-properties')">
        <mat-icon>favorite</mat-icon>
        <span>Saved Properties</span>
      </button>
      <button class="menu-action" (click)="onAddClick('manage-properties')">
        <mat-icon>bungalow</mat-icon>
        <span>Manage Properties</span>
      </button>
      <button class="menu-action" (click)="onAddClick('admin')" *ngIf="hasRole(['admin'])">
        <mat-icon>shield</mat-icon>
        <span>Admin</span>
      </button>
      <button class="menu-action" (click)="onAddClick('sales')" *ngIf="hasRole(['admin', 'sales'])">
        <mat-icon>analytics</mat-icon>
        <span>Sales Dashboard</span>
      </button>
      <button class="menu-action" (click)="onAddClick('profile')" *ngIf="user">
        <mat-icon>person</mat-icon>
        <span>Profile</span>
      </button>
      <button class="menu-action" (click)="onAddClick('logout')" *ngIf="user">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </div>
  </nav>

  <button mat-fab class="metallic-bubble-btn-green location-btn" [class.rotated]="isMenuOpen" (click)="toggleMenu()">
    <mat-icon [style.transform]="isMenuOpen ? 'rotate(90deg)' : 'none'" style="transition: transform 0.3s ease;">
      add
    </mat-icon>
  </button>
</div>
